import { reatomAsync } from '@reatom/async';
import { BACKEND_API, type RegisterRequest } from '@trwl/backend.api';
import { onLoginAction } from '@trwl/store/atoms';

export const signupAction = reatomAsync(
  async (ctx, registerRequest: RegisterRequest) =>
    await BACKEND_API.AuthApi.register(registerRequest).then(() =>
      onLoginAction(ctx),
    ),
  'signupAction',
);
